import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = ({ profile, currentLanguage }) => {
  const translations = {
    en: {
      title: 'Trust & Verification',
      identityVerified: 'Identity Verified',
      emailVerified: 'Email Verified',
      phoneVerified: 'Phone Verified',
      verified: 'Verified',
      notVerified: 'Not Verified'
    },
    ko: {
      title: '신뢰 및 인증',
      identityVerified: '신원 인증',
      emailVerified: '이메일 인증',
      phoneVerified: '전화 인증',
      verified: '인증됨',
      notVerified: '미인증'
    }
  };

  const t = translations?.[currentLanguage];

  const indicators = [
    {
      label: t?.identityVerified,
      verified: profile?.is_verified,
      icon: 'ShieldCheck'
    },
    {
      label: t?.emailVerified,
      verified: !!profile?.email,
      icon: 'Mail'
    },
    {
      label: t?.phoneVerified,
      verified: !!profile?.phone,
      icon: 'Phone'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-md overflow-hidden">
      <div className="p-4 md:p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
            <Icon name="Shield" size={20} color="var(--color-success)" />
          </div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            {t?.title}
          </h2>
        </div>
      </div>

      <div className="p-4 md:p-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {indicators?.map((indicator, index) => (
            <div
              key={index}
              className={`p-4 rounded-lg border-2 transition-colors ${
                indicator?.verified
                  ? 'bg-success/5 border-success/30' :'bg-muted/20 border-border'
              }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                    indicator?.verified ? 'bg-success/10' : 'bg-muted/30'
                  }`}
                >
                  <Icon
                    name={indicator?.icon}
                    size={20}
                    color={indicator?.verified ? 'var(--color-success)' : 'var(--color-muted-foreground)'}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground mb-1">
                    {indicator?.label}
                  </div>
                  <div
                    className={`text-xs font-medium ${
                      indicator?.verified ? 'text-success' : 'text-muted-foreground'
                    }`}
                  >
                    {indicator?.verified ? t?.verified : t?.notVerified}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;